import Vue from "vue";
import Vuex from "vuex";

import app from "@/store/modules/app";
import auth from "@/store/modules/auth";
import catalogs from "@/store/modules/catalogs";
import charts from "@/store/modules/charts";
import confirmDialog from "@/store/modules/confirmDialog";
import dashboardsTemplates from "@/store/modules/dashboardsTemplates";
import filters from "@/store/modules/filters";
import localJobs from "@/store/modules/localJobs";
import pageEdit from "@/store/modules/pageEdit";
import planCreate from "@/store/modules/planCreate";
import planList from "@/store/modules/planList";
import projectEdit from "@/store/modules/projectEdit";
import projectLayoutEdit from "@/store/modules/projectLayoutEdit";
import projectOutput from "@/store/modules/projectOutput";
import projects from "@/store/modules/projects";
import projectsTemplates from "@/store/modules/projectsTemplates";
import scenarioComparison from "@/store/modules/scenarioComparison";
import userSettings from "@/store/modules/userSettings";

Vue.use(Vuex);

export interface RootState {
  appVersion: string;
}

export default new Vuex.Store({
  state: {
    appVersion: "",
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    planCreate,
    planList,
    projects,
    projectOutput,
    projectLayoutEdit,
    scenarioComparison,
    projectEdit,
    userSettings,
    app,
    localJobs,
    catalogs,
    pageEdit,
    charts,
    dashboardsTemplates,
    projectsTemplates,
    filters,
    confirmDialog,
  },
});
